import iHeartMessage from "../../../assets/icons/heart-message.svg";
import iHeroTextBgLeftBottom from "../../../assets/icons/hero-text-block/hero-text-bg-left-bottom.png";
import iHeroTextBgLeftCenter from "../../../assets/icons/hero-text-block/hero-text-bg-left-center.png";
import iHeroTextBgRight from "../../../assets/icons/hero-text-block/hero-text-bg-right.png";
import iHeroTextBlockLineBottom from "../../../assets/icons/hero-text-block/line-bottom.svg";
import iHeroTextBlockLineUpper from "../../../assets/icons/hero-text-block/line-upper.svg";
import { useWidth } from "../../../hooks/use-width";
import "./hero-text-block.sass";

const HeroTextBlock = () => {
  const { isMobileWidth } = useWidth();
  return (
    <div className="hero-text-block">
      {!isMobileWidth && (
        <div className="hero-text-block__text">
          От стратегии и <br /> креативной концепции до реализации:
          <br />
          <div className="hero-text-block__text-special">
            делаем&nbsp;всё,
            <br />
            чтобы&nbsp;бренд&nbsp;запомнили
            <img
              src={iHeroTextBlockLineUpper}
              className="img-absolute hero-text-block__line-upper"
              alt=""
            />
            <img
              src={iHeroTextBlockLineBottom}
              className="img-absolute hero-text-block__line-bottom"
              alt=""
            />
          </div>
        </div>
      )}

      {isMobileWidth && (
        <div className="hero-text-block__text">
          От стратегии <br /> и креативной
          <br /> концепции до реализации:
          <br />
          <div className="hero-text-block__text-special">
            делаем&nbsp;всё,
            <br />
            чтобы&nbsp;бренд
            <br />
            запомнили
            <img
              src={iHeroTextBlockLineUpper}
              className="img-absolute hero-text-block__line-upper"
              alt=""
            />
            <img
              src={iHeroTextBlockLineBottom}
              className="img-absolute hero-text-block__line-bottom"
              alt=""
            />
          </div>
        </div>
      )}

      <img
        src={iHeroTextBgRight}
        className="img-absolute hero-text-block__bg-left-upper"
        alt=""
      />

      <img
        src={iHeroTextBgLeftCenter}
        className="img-absolute hero-text-block__bg-left-center"
        alt=""
      />

      <img
        src={iHeroTextBgLeftBottom}
        className="img-absolute hero-text-block__bg-left-bottom"
        alt=""
      />

      <img
        src={iHeroTextBgRight}
        className="img-absolute hero-text-block__bg-right"
        alt=""
      />

      <img
        src={iHeartMessage}
        className="img-absolute hero-text-block__heart"
        alt=""
      />
    </div>
  );
};

export default HeroTextBlock;
